<div id="titlebar">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h2>Terms and Conditions</h2>
        <nav id="breadcrumbs">
          <ul>
            <li><a [routerLink]="['/']">Home</a></li>
            <li>Terms and Conditions</li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="style-1">
        <p>Welcome to pakmatti.com. These terms and conditions outline the rules and regulations for the use of pakmatti.com's Website.</p>
        
        <h3>1. Terms</h3>
        <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use pakmatti.com if you do not agree to take all of the terms and conditions stated on this page.</p>

        <h3>2. Cookies</h3>
        <p>We employ the use of cookies. By accessing pakmatti.com, you agreed to use cookies in agreement with the pakmatti.com's Privacy Policy.</p>

        <h3>3. License</h3>
        <p>Unless otherwise stated, pakmatti.com and/or its licensors own the intellectual property rights for all material on pakmatti.com. All intellectual property rights are reserved.</p>

        <h3>4. User Comments</h3>
        <p>Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. pakmatti.com does not filter, edit, publish or review Comments prior to their presence on the website.</p>

        <h3>5. Content Liability</h3>
        <p>We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website.</p>
      </div>
    </div>
  </div>
</div>
